import React, { useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify';
import { getArrivalDepartureReport, exportArrivalAndDepartureReportCSV } from '../../../axios/Report/ReportUrlApi';
import dayjs from 'dayjs';
import { useAuth } from '../../../context/AuthContext'
import {
    ReportPageHeader,
    ReportDateFilterRow,
} from './ReportSharedComponents';

const ArrivalAndDepartureReport = (props) => {
    const { onBack, setLoading, handleFilter, dataFilter, page, pageSize, getTabName, profile, isAdmin, totalPages } = props;
    const { dateTimeFormat } = useAuth();
    const { t, i18n } = useTranslation()
    const currentLang = i18n.language;

    function formatDateTime(date) {
        const yyyy = date.getFullYear();
        const MM = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
    }

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const initialFormData = {
        sumBy: "1",
        startDate: new Date(yesterday),
        endDate: new Date(yesterday),
        showTime: "h-m-s",
        groupByDevices: false,
        showEvents: false,
        showEventsRadio: "first-and-last"
    }


    const [formData, setFormData] = useState(initialFormData)

    const bodyRequest = {
        "reportCycleTypeId": formData?.sumBy ? Number(formData.sumBy) : 1,
        "fromDate": formData.startDate?.target?.value
            ? formatDateTime(formData.startDate.target.value)
            : formatDateTime(formData.startDate),
        "toDate": formData.endDate?.target?.value
            ? formatDateTime(formData.endDate.target.value)
            : formatDateTime(formData.endDate),
        "userId": isAdmin ? (dataFilter?.userName ? dataFilter.userName : null) : profile.userId,
        "userTypeId": null,
        "shiftId": dataFilter?.shift ? dataFilter.shift : 0,
        "groupId": dataFilter?.userGroup ? dataFilter.userGroup : null,
        "pageNo": page + 1,
        "recordPerPage": pageSize,
        "showTime": formData.showTime,
        "lang": currentLang
    }

    const fetchData = async () => {
        let convertShiftId = bodyRequest?.shiftId;
        if (typeof convertShiftId === 'object' && Array.isArray(convertShiftId)) {
            convertShiftId = parseInt(convertShiftId[0], 10);
        }
        const payload = {
            ...bodyRequest,
            shiftId: convertShiftId,
        };
        try {
            setLoading(true);
            const response = await getArrivalDepartureReport(payload);
            if (response.data.message === 'Successful' || response.data.message === 'Thành công') {
                // setUserData(response.data.listEmployeeData);
                handleFilter({
                    ...response.data, pagination: {
                        ...response.data.pagination,
                        currentPage: response.data.pagination.currentPage - 1
                    }
                });
                setLoading(false);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (dataFilter?.shift || dataFilter?.userName || page || pageSize) {
            fetchData();
        }
    }, [dataFilter.shift, dataFilter.userName, formData, page, pageSize]);


    useEffect(() => {
        getTabName("ArrivalAndDepartureReport")
    }, []);

    function getCurrentTimestamp() {
        const now = new Date();
        const yyyy = now.getFullYear();
        const MM = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const HH = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');

        return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
    }

    const exportCSV = async () => {
        let convertShiftId = bodyRequest?.shiftId;
        if (typeof convertShiftId === 'object' && Array.isArray(convertShiftId)) {
            convertShiftId = parseInt(convertShiftId[0], 10);
        }
        const payload = {
            ...bodyRequest,
            shiftId: convertShiftId,
            formatDate: dateTimeFormat,
            pageNo: totalPages
        };
        try {
            setLoading(true);
            const response = await exportArrivalAndDepartureReportCSV(payload);

            if (response) {
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                const filename = `${t("export.ArrivalAndDepartureReport")}_${getCurrentTimestamp()}.xlsx`;

                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className='total-work-hours-report'>
            <ReportPageHeader
                onBack={onBack}
                titleKey="common.arrival-and-departure-report"
                onExport={exportCSV}
                startDate={formData.startDate}
                endDate={formData.endDate}
                onUpdateSuccess={fetchData}
            />
            <ReportDateFilterRow
                formData={formData}
                setFormData={setFormData}
            />
        </div>
    )
}

export default ArrivalAndDepartureReport